/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getPatientConditions } from 'app/entities/patient-condition/patient-condition.reducer';
import { getEntities as getICD10Diagnoses } from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tumor.reducer';

export const TumorUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const patientConditions = useAppSelector(state => state.patientCondition.entities);
  const iCD10Diagnoses = useAppSelector(state => state.iCD10Diagnosis.entities);
  const tumorEntity = useAppSelector(state => state.tumor.entity);
  const loading = useAppSelector(state => state.tumor.loading);
  const updating = useAppSelector(state => state.tumor.updating);
  const updateSuccess = useAppSelector(state => state.tumor.updateSuccess);

  const handleClose = () => {
    navigate(`/tumor${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getPatientConditions({}));
    dispatch(getICD10Diagnoses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.incidentDate !== undefined && typeof values.incidentDate !== 'number') {
      values.incidentDate = Number(values.incidentDate);
    }
    if (values.createDate !== undefined && typeof values.createDate !== 'number') {
      values.createDate = Number(values.createDate);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorEntity,
      ...values,
      topography: clinicalDictionaries.find(it => it.id.toString() === values.topography?.toString()),
      morphology: clinicalDictionaries.find(it => it.id.toString() === values.morphology?.toString()),
      behaviour: clinicalDictionaries.find(it => it.id.toString() === values.behaviour?.toString()),
      basisOfDiagnosis: clinicalDictionaries.find(it => it.id.toString() === values.basisOfDiagnosis?.toString()),
      icccCode: clinicalDictionaries.find(it => it.id.toString() === values.icccCode?.toString()),
      condition: patientConditions.find(it => it.id.toString() === values.condition?.toString()),
      diagnosis: iCD10Diagnoses.find(it => it.id.toString() === values.diagnosis?.toString()),
      grade: clinicalDictionaries.find(it => it.id.toString() === values.grade?.toString()),
      tumorStatus: clinicalDictionaries.find(it => it.id.toString() === values.tumorStatus?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tumorEntity,
          topography: tumorEntity?.topography?.id,
          morphology: tumorEntity?.morphology?.id,
          behaviour: tumorEntity?.behaviour?.id,
          basisOfDiagnosis: tumorEntity?.basisOfDiagnosis?.id,
          icccCode: tumorEntity?.icccCode?.id,
          condition: tumorEntity?.condition?.id,
          diagnosis: tumorEntity?.diagnosis?.id,
          grade: tumorEntity?.grade?.id,
          tumorStatus: tumorEntity?.tumorStatus?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumor.home.createOrEditLabel" data-cy="TumorCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumor.home.createOrEditLabel">Create or edit a Tumor</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-id"
                  label={translate('tinyMedicRestApp.tumor.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.incidentDate')}
                id="tumor-incidentDate"
                name="incidentDate"
                data-cy="incidentDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.createdBy')}
                id="tumor-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.createDate')}
                id="tumor-createDate"
                name="createDate"
                data-cy="createDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.lastUpdated')}
                id="tumor-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.lastModifiedBy')}
                id="tumor-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.active')}
                id="tumor-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.cursor')}
                id="tumor-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.microSec')}
                id="tumor-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tumor.timestampEntry')}
                id="tumor-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField label={translate('tinyMedicRestApp.tumor.notes')} id="tumor-notes" name="notes" data-cy="notes" type="text" />
              <ValidatedField
                id="tumor-topography"
                name="topography"
                data-cy="topography"
                label={translate('tinyMedicRestApp.tumor.topography')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-morphology"
                name="morphology"
                data-cy="morphology"
                label={translate('tinyMedicRestApp.tumor.morphology')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-behaviour"
                name="behaviour"
                data-cy="behaviour"
                label={translate('tinyMedicRestApp.tumor.behaviour')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-basisOfDiagnosis"
                name="basisOfDiagnosis"
                data-cy="basisOfDiagnosis"
                label={translate('tinyMedicRestApp.tumor.basisOfDiagnosis')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-icccCode"
                name="icccCode"
                data-cy="icccCode"
                label={translate('tinyMedicRestApp.tumor.icccCode')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-condition"
                name="condition"
                data-cy="condition"
                label={translate('tinyMedicRestApp.tumor.condition')}
                type="select"
              >
                <option value="" key="0" />
                {patientConditions
                  ? patientConditions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-diagnosis"
                name="diagnosis"
                data-cy="diagnosis"
                label={translate('tinyMedicRestApp.tumor.diagnosis')}
                type="select"
              >
                <option value="" key="0" />
                {iCD10Diagnoses
                  ? iCD10Diagnoses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="tumor-grade" name="grade" data-cy="grade" label={translate('tinyMedicRestApp.tumor.grade')} type="select">
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-tumorStatus"
                name="tumorStatus"
                data-cy="tumorStatus"
                label={translate('tinyMedicRestApp.tumor.tumorStatus')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorUpdate;
